module.exports = __webpack_public_path__ + "img/jsjls.6acb4cdd.jpg";